import type { TourSection } from './types';

export const categoriesSections: TourSection[] = [
  {
    id: 'tree',
    label: 'Árbol de categorías',
    steps: [
      {
        target: '[data-tour="categories-tree"]',
        title: 'Árbol jerárquico',
        content:
          'Listado de todas las categorías ordenadas como un árbol. Click en el botón triangular abre o cierra una rama. Click en el nombre selecciona la categoría y muestra su detalle a la derecha.',
        placement: 'right',
      },
    ],
  },
  {
    id: 'detail-panel',
    label: 'Panel de edición',
    steps: [
      {
        target: '[data-tour="categories-detail"]',
        title: 'Datos de la categoría',
        content:
          'Editas el nombre, la descripción, la categoría padre (de qué cuelga) y el orden en que aparece dentro del árbol. Al guardar, el árbol se actualiza solo.',
        placement: 'left',
      },
    ],
  },
  {
    id: 'tree-actions',
    label: 'Crear nuevas categorías',
    steps: [
      {
        target: '[data-tour="categories-tree-actions"]',
        title: 'Crear y eliminar',
        content:
          '"Nueva raíz" agrega una categoría principal (sin padre). Desde el panel de edición puedes crear sub-categorías que cuelguen de la seleccionada. No se puede eliminar una categoría si tiene productos o sub-categorías asignadas.',
      },
    ],
  },
];
